import { ensureState } from 'redux-optimistic-ui';

export const messages = s => ensureState(s).messages;
export const list = s => ensureState(s).photos.get('list');
export const loading = s => ensureState(s).photos.get('loading');
export const error = s => ensureState(s).photos.get('error');
